<!--头部快捷导航-->
<template>
  <div class="new_top_tools">
    <div class="ntt_main">
      <router-link v-if="!isIndex" class="nttm_goindex" to="/">网站首页</router-link>
      <!--<router-link title="证书查询" to="/certificateQuery" class="nttm_zscx">证书查询</router-link>
      <div class="nttm_khdxz">客户端下载
        <div class="nttm_khdxz_disk">
          <div class="top_qrcode">
            <div class="tpqc">
              <div class="tpqc_img"><img src="../assets/img-4/mobile_yiboshi.gif" width="88" height="88"></div>
              <div class="tpqc_right">
                <p>医博士APP</p>
                <span class="tpqcr_ios">iphone</span>
                <span class="tpqcr_android">android</span>
              </div>
            </div>
            <div class="tpqc">
              <div class="tpqc_img"><img src="../assets/img-4/mobile_zhikaolianba.gif" width="88" height="88"></div>
              <div class="tpqc_right">
                <p>执考练吧APP</p>
                <span class="tpqcr_ios">iphone</span>
                <span class="tpqcr_android">android</span>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <router-link class="nttm_gywm" title="关于我们" to="/about">关于我们</router-link>
      <router-link class="nttm_xsbz" title="新手帮助" to="/help">新手帮助</router-link>
      <a v-if="userInfo" class="nttm_exit" href="javascript:" @click="logout">退出</a>
      <div v-if="userInfo" class="nttm_user">{{ userInfo.realName }}
        <div class="nttm_user_disk">
          <div class="nttmud_head"><img :src="userInfo.imageUrl"/></div>
          <div class="nttmud_info">
            <p class="textover">{{ userInfo.realName }}</p>
            <p>{{ userInfo.company.companyName }}</p>
          </div>
          <div class="clear"></div>
          <div class="nttmud_a">
            <router-link :to="{ path: '/EditUser', query: { baseVisible: true }}">帐号设置</router-link>
            <router-link :to="{ path: '/EditUser', query: { pwdVisible: true }}">修改密码</router-link>
            <router-link title="我的培训" to="/usercenter">我的培训</router-link>
          </div>
        </div>
      </div>
      <div class="nttm_telNum">400-822-2055</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      showAppDownload: false,
      isIndex: false,
      showUserMenu: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted() {
    if (this.$route.path == '/') {
      this.isIndex = true
    }
  },
  methods: {
    ...mapActions([
      'userLogout'
    ]),
    logout() {
      this.userLogout()
    }
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/Shortcut.vue